/* Header behaviour: mega menu open/close, predictive search, brand filter.
   Without this file every menu link and the search form still work. */

(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_header']) return;
  window.__hwsLoaded['component_header'] = true;


  var strings = window.hwsStrings || {};
  var config = window.hwsSettings || {};

  /* ------------------------------------------------------------ mega menu */

  function initMegaMenus(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-header-nav]').forEach(function (nav) {
      if (nav.dataset.megaReady === 'true') return;
      nav.dataset.megaReady = 'true';
      var closeTimer = null;

      function closeAll(except) {
        nav.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
          var panel = document.getElementById(trigger.getAttribute('aria-controls'));
          if (panel === except) return;
          trigger.setAttribute('aria-expanded', 'false');
          if (panel) panel.hidden = true;
        });
      }

      function open(trigger) {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!panel) return;
        closeAll(panel);
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }

      nav.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-mega-trigger]');
        if (!trigger) return;
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          /* second click follows the link */
          return;
        }
        event.preventDefault();
        open(trigger);
      });

      /* Op een aanraakscherm stuurt één tik eerst mouseover en daarna click. Het
         menu ging dan open door de mouseover, waarna de click-handler dachtte dat
         het de tweede tik was en meteen naar de categorie navigeerde. Tussen 750 en
         989px (telefoon liggend, tablet) is dit menu de enige weg naar de
         subcategorieën, dus daar viel die route helemaal weg. */
      var echteMuis = window.matchMedia('(hover: hover) and (pointer: fine)');
      nav.addEventListener('mouseover', function (event) {
        if (!echteMuis.matches) return;
        var item = event.target.closest('.header-nav__item--has-menu');
        window.clearTimeout(closeTimer);
        if (!item) {
          /* Hover op een menu-item zonder submenu: het open mega menu sluiten,
             anders blijft het over de pagina hangen. */
          if (event.target.closest('.header-nav__item')) closeAll();
          return;
        }
        var trigger = item.querySelector('[data-mega-trigger]');
        if (trigger) open(trigger);
      });

      nav.addEventListener('mouseleave', function () {
        closeTimer = window.setTimeout(closeAll, 150);
      });

      nav.addEventListener('focusin', function (event) {
        var item = event.target.closest('.header-nav__item--has-menu');
        if (!item) {
          closeAll();
          return;
        }
        var trigger = item.querySelector('[data-mega-trigger]');
        if (trigger) open(trigger);
      });

      nav.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var openTrigger = nav.querySelector('[data-mega-trigger][aria-expanded="true"]');
        closeAll();
        if (openTrigger) openTrigger.focus();
      });

      document.addEventListener('click', function (event) {
        if (!nav.contains(event.target)) closeAll();
      });
    });
  }

  /* ------------------------------------------------- balk bovenaan (mobiel) */

  /* Op een telefoon is de balk 390px breed terwijl er 931px aan boodschappen in
     staat: je zag alleen "Voor 16:00 besteld" half staan en moest dat strookje
     zelf opzij vegen om de rest te vinden. Hij loopt nu vanzelf door, rustig, en
     herhaalt zichzelf. Daarvoor staat de inhoud er twee keer in; de kopie is voor
     schermlezers verborgen en niet aan te klikken, zodat niets dubbel voorkomt. */
  function initUtilityMarquee() {
    var inner = document.querySelector('.header-utility__inner');
    if (!inner || inner.dataset.marqueeReady === 'true') return;
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    /* Wie beweging heeft uitgezet krijgt gewoon de veegbare balk. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var kinderen = Array.prototype.slice.call(inner.children);
    if (!kinderen.length) return;
    inner.dataset.marqueeReady = 'true';

    var spoor = document.createElement('div');
    spoor.className = 'header-utility__track';
    kinderen.forEach(function (kind) { spoor.appendChild(kind); });

    var kopie = spoor.cloneNode(true);
    kopie.setAttribute('aria-hidden', 'true');
    /* Alleen de id's eruit — die mogen maar één keer voorkomen. De knoppen zelf
       blijven gewoon werken: eerst haalde ik ook data-overlay-open weg, en dan was
       de helft van de band een dood vlak. Je tikte op "453 beoordelingen" in die
       kopie en er gebeurde niets. Wel tabindex -1, zodat wie met het toetsenbord
       werkt niet twee keer langs dezelfde knoppen loopt. */
    kopie.querySelectorAll('[id]').forEach(function (el) {
      el.removeAttribute('id');
    });
    kopie.querySelectorAll('a, button').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });

    var band = document.createElement('div');
    band.className = 'header-utility__marquee';
    band.appendChild(spoor);
    band.appendChild(kopie);
    inner.appendChild(band);

    /* Even snel voor iedereen: de looptijd volgt de breedte, ongeveer 45px per
       seconde. Een korte balk raast anders voorbij en een lange kruipt. */
    /* Zelf doorschuiven in plaats van met een CSS-animatie.

       Met een animatie op de band moest het vak op overflow:hidden, en daarmee was
       zelf zijwaarts vegen niet meer mogelijk — je zat vast aan wat er net toevallig
       stond. Nu verschuiven we gewoon de scrollstand: de browser laat vegen dan
       gewoon toe, en wij duwen hem er gestaag doorheen. Ongeveer 45px per seconde.

       De inhoud staat er twee keer in, dus zodra we een hele kopie verder zijn
       zetten we de stand terug met precies die breedte. Dat is op het scherm niet
       te zien, want daar staat exact hetzelfde. */
    var perSeconde = 55;
    /* Breedte één keer meten en alleen opnieuw bij een andere maat: elk beeldje
       meten dwong de browser steeds tot een nieuwe opmaak, ook tijdens het laden. */
    var eenKopie = 0;
    var inBeeld = true;
    function meet() { eenKopie = spoor.getBoundingClientRect().width; }
    if (typeof ResizeObserver === 'function') new ResizeObserver(meet).observe(spoor);
    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (items) { inBeeld = items[0].isIntersecting; }).observe(inner);
    }
    var vorigeTijd = null;
    var stilTot = 0;
    var positie = 0;

    /* De stand wordt als kommagetal bijgehouden en pas bij het wegzetten afgerond.
       Optellen bíj scrollLeft ging mis: die waarde rondt de browser af op hele
       pixels, en bij ongeveer 0,9px per beeldje werd dat meestal 0 en af en toe 1.
       Het resultaat was een schokkerig stapje-voor-stapje, en trager dan bedoeld
       omdat elke afronding de rest weggooide. */
    function stap(tijd) {
      window.requestAnimationFrame(stap);
      if (vorigeTijd === null) vorigeTijd = tijd;
      var delta = Math.min(tijd - vorigeTijd, 100);
      vorigeTijd = tijd;
      if (document.hidden) return;

      if (!inBeeld) return;
      if (eenKopie <= 0) return;

      if (tijd < stilTot) {
        /* Stilgezet of zelf aan het vegen: de eigen stand volgen, zodat hij
           daarvandaan verder loopt en niet terugspringt. */
        positie = inner.scrollLeft;
        return;
      }

      positie += (perSeconde * delta) / 1000;
      if (positie >= eenKopie) positie -= eenKopie;
      inner.scrollLeft = Math.round(positie);
    }

    /* Aanraken zet hem stil, zodat je rustig kunt lezen en tikken; daarna loopt hij
       vanzelf weer door. Vegen werkt gewoon, want het is een echt schuifvlak. */
    function pauzeer(ms) {
      stilTot = performance.now() + ms;
    }

    inner.addEventListener('pointerdown', function () { pauzeer(600000); });
    inner.addEventListener('focusin', function () { pauzeer(600000); });
    inner.addEventListener('pointerup', function () { pauzeer(4000); });
    inner.addEventListener('pointercancel', function () { pauzeer(2000); });
    inner.addEventListener('pointerleave', function () { pauzeer(800); });
    inner.addEventListener('focusout', function () { pauzeer(1500); });
    /* Met de muis erboven ook stil, net als eerst. */
    inner.addEventListener('mouseenter', function () { pauzeer(600000); });
    inner.addEventListener('mouseleave', function () { pauzeer(300); });

    /* Pas lopen als de pagina geladen is: eerder snoepte hij rekentijd van de rest. */
    function start() { meet(); window.requestAnimationFrame(stap); }
    if (document.readyState === 'complete') setTimeout(start, 1500);
    else window.addEventListener('load', function () { setTimeout(start, 1500); }, { once: true });
  }

  /* -------------------------------------------------------- brand filter */

  /* Het merkenmenu toont vier letterkolommen tegelijk, zoals het ontwerp. De
     letterrij springt naar de bladzijde waar die letter op staat, de pijlen gaan
     een bladzijde vooruit of terug, en het zoekveld kijkt door alle letters heen
     (dan vervalt het bladeren, want dan wil je álle treffers zien). */
  function initBrandFilter(root) {
    (root || document).querySelectorAll('[data-mega-brands]').forEach(function (wrap) {
      if (wrap.dataset.brandsReady === 'true') return;
      wrap.dataset.brandsReady = 'true';

      var input = wrap.querySelector('[data-brand-filter]');
      var empty = wrap.querySelector('[data-brand-empty]');
      var groups = Array.prototype.slice.call(wrap.querySelectorAll('[data-brand-group]'));
      var letterButtons = Array.prototype.slice.call(wrap.querySelectorAll('[data-brand-letter]'));
      var pagerText = wrap.querySelector('[data-brand-pager-text]');
      var prev = wrap.querySelector('[data-brand-prev]');
      var next = wrap.querySelector('[data-brand-next]');
      var groepenVak = wrap.querySelector('[data-brand-groups]');
      var totaal = parseInt(wrap.dataset.brandTotal, 10) || 0;
      var actieveLetter = '';

      /* De pijlen schuiven de strook een schermbreedte op. Ze gaan uit zodra je aan
         het begin of het eind bent, zodat je ziet dat er niets meer komt. */
      function werkPijlenBij() {
        if (!groepenVak) return;
        /* Zolang het menu dicht is meet de strook 0 breed. Daar viel uit af te
           leiden dat we aan het einde stonden, waarna beide pijlen uitgingen en
           uit bleven — er werd immers nooit meer gescrold. Bij een breedte van 0
           weten we simpelweg niets, dus laten we ze dan met rust. */
        if (groepenVak.clientWidth === 0) return;
        var max = groepenVak.scrollWidth - groepenVak.clientWidth;
        var x = groepenVak.scrollLeft;
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = x >= max - 2;
      }

      function schuifNaar(doel) {
        if (!groepenVak || !doel) return;
        /* Niet met offsetLeft rekenen: dat is de afstand tot het eerste bovenliggende
           element met een eigen positie, en dat hoeft de strook niet te zijn. Via de
           gemeten posities plus de huidige stand klopt het altijd. */
        var verschil =
          doel.getBoundingClientRect().left - groepenVak.getBoundingClientRect().left;
        /* Gewoon de stand zetten; het vloeiend schuiven regelt de CSS met
           scroll-behavior. Gaven we hier zelf behavior mee, dan overrulede dat de
           stijl en was het gedrag niet meer met de CSS bij te stellen. */
        groepenVak.scrollLeft = groepenVak.scrollLeft + verschil;
      }

      /* Eén keer de platte naam per merk onthouden, zodat typen niet elke keer
         alle namen opnieuw hoeft te normaliseren. */
      var alleLinks = [];
      groups.forEach(function (group) {
        Array.prototype.slice.call(group.querySelectorAll('[data-brand-item]')).forEach(function (a) {
          alleLinks.push({ el: a, plat: plat(a.textContent), group: group });
        });
      });

      function zetTekst(gevonden, term) {
        if (!pagerText) return;
        /* De regel staat al goed in de pagina ("Alle 56 merken · gebruik de
           letters of het zoekveld"); die onthouden we, zodat hij terugkomt zodra
           het zoekveld weer leeg is. */
        if (!pagerText.dataset.standaard) pagerText.dataset.standaard = pagerText.textContent;
        if (term) {
          var found = pagerText.getAttribute('data-tpl-found') || '%count%';
          if (gevonden === 1) found = pagerText.getAttribute('data-tpl-found-one') || found;
          pagerText.textContent = found.replace('%count%', gevonden);
          return;
        }
        pagerText.textContent = pagerText.dataset.standaard;
      }

      function toon() {
        var term = plat(input ? input.value : '');
        var gevonden = 0;

        if (term) {
          /* Zoeken: alle letters meenemen, alleen de treffers laten staan. */
          alleLinks.forEach(function (item) {
            var raak = item.plat.indexOf(term) !== -1;
            item.el.hidden = !raak;
            if (raak) gevonden++;
          });
          groups.forEach(function (group) {
            group.hidden = !group.querySelector('[data-brand-item]:not([hidden])');
          });
        } else {
          /* Alle letters staan er; je schuift er met de pijlen of de letterrij
             langs. Ze werden eerst per vier getoond en de rest verborgen, waardoor
             je van 56 merken er elf zag en zes keer moest doorklikken. */
          alleLinks.forEach(function (item) {
            item.el.hidden = false;
          });
          groups.forEach(function (group) {
            group.hidden = false;
          });
          gevonden = totaal;
        }

        if (empty) empty.hidden = gevonden !== 0;
        werkPijlenBij();
        letterButtons.forEach(function (button) {
          var eigen = button.getAttribute('data-brand-letter');
          button.setAttribute('aria-pressed', eigen === actieveLetter && !term ? 'true' : 'false');
        });
        zetTekst(gevonden, term);
      }

      if (input) {
        input.addEventListener('input', function () {
          actieveLetter = '';
          toon();
        });
      }

      letterButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          /* Het merkenmenu hangt onder het menu-item "Merken", en dat is een link.
             Zonder dit borrelde de klik daarheen door en sprong de bezoeker naar de
             merkenpagina in plaats van dat de strook opzij schoof. */
          event.preventDefault();
          event.stopPropagation();
          var letter = button.getAttribute('data-brand-letter');
          var doel = null;
          groups.forEach(function (group) {
            if (!doel && group.getAttribute('data-brand-group') === letter) doel = group;
          });
          if (!doel) return;
          if (input) input.value = '';
          actieveLetter = letter;
          toon();
          /* De strook schuift naar die letter toe; hij blijft dus staan tussen de
             letters ervoor en erna in plaats van dat er een andere set verschijnt. */
          schuifNaar(doel);
        });
      });

      if (prev) {
        prev.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (!groepenVak) return;
          actieveLetter = '';
          groepenVak.scrollLeft = groepenVak.scrollLeft - groepenVak.clientWidth;
          toon();
        });
      }

      if (next) {
        next.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (!groepenVak) return;
          actieveLetter = '';
          groepenVak.scrollLeft = groepenVak.scrollLeft + groepenVak.clientWidth;
          toon();
        });
      }

      if (groepenVak) {
        groepenVak.addEventListener('scroll', werkPijlenBij, { passive: true });
        /* Het menu is dicht bij het laden, en dan meet de strook 0 breed: beide
           pijlen gingen daardoor meteen uit en bleven uit, want zonder scrollen werd
           er nooit opnieuw gekeken. Zodra het paneel opengaat krijgt de strook een
           breedte en rekenen we het opnieuw uit. De waarnemer moet in een variabele
           blijven staan, anders ruimt de browser hem op. */
        if (typeof ResizeObserver === 'function') {
          wrap.__hwsStrookWaarnemer = new ResizeObserver(werkPijlenBij);
          wrap.__hwsStrookWaarnemer.observe(groepenVak);
        }
      }

      /* Sluitknop in de kopregel: hetzelfde effect als de Escape-toets, dus het
         paneel dicht en de aandacht terug naar het menu-item. */
      var close = wrap.querySelector('[data-brand-close]');
      if (close) {
        close.addEventListener('click', function () {
          var panel = wrap.closest('.mega-menu');
          if (!panel) return;
          panel.hidden = true;
          var trigger = document.querySelector('[data-mega-trigger][aria-controls="' + panel.id + '"]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.focus();
          }
        });
      }

      toon();
    });
  }

  /* ------------------------------------------------ zoektermen verbeteren */

  /* Shopify zoekt letterlijk. "loreal" levert niets op, want de winkel schrijft
     "L'Oréal Professionnel"; "sampoo" levert niets op omdat er één letter mist.
     Deze hulpjes leggen de getypte tekst naast de namen die in deze winkel echt
     bestaan (snippets/search-dictionary.liquid) en kiezen de juiste term. Alleen
     bij een duidelijke overeenkomst — bij twijfel gebeurt er niets. */

  var Dict = {
    klaar: false,
    merken: [],
    woorden: [],
    regels: {},
    max: 2,

    voorbereid: function () {
      if (Dict.klaar) return Dict;
      Dict.klaar = true;
      var bron = window.hwsSearchDict;
      if (!bron) return Dict;
      if (typeof bron.maxDistance === 'number') Dict.max = bron.maxDistance;

      /* Merken en collecties komen in dezelfde lijst: bij beide wil je op enter
         naar die pagina. Merken staan vooraan, dus die winnen bij gelijke naam. */
      (bron.brands || []).forEach(function (merk) {
        if (!merk || !merk.n) return;
        Dict.merken.push({ naam: merk.n, plat: plat(merk.n), url: merk.u || '', soort: 'merk' });
      });
      (bron.collections || []).forEach(function (coll) {
        if (!coll || !coll.n) return;
        var plat_naam = plat(coll.n);
        var bestaat = Dict.merken.some(function (m) { return m.plat === plat_naam; });
        if (bestaat) return;
        Dict.merken.push({ naam: coll.n, plat: plat_naam, url: coll.u || '', soort: 'collectie' });
      });
      (bron.types || []).forEach(function (naam) {
        if (naam) Dict.woorden.push({ naam: naam, plat: plat(naam) });
      });
      /* Losse woorden uit merk- en soortnamen, zodat "sampoo" ook aanslaat als
         de soort "Shampoo & conditioner" heet. */
      Dict.merken.concat(Dict.woorden).forEach(function (item) {
        item.plat.split(' ').forEach(function (woord) {
          if (woord.length < 4) return;
          var bestaat = Dict.woorden.some(function (w) {
            return w.plat === woord;
          });
          if (!bestaat) Dict.woorden.push({ naam: woord, plat: woord });
        });
      });

      (bron.rules || '').split('\n').forEach(function (regel) {
        var delen = regel.split('=');
        if (delen.length < 2) return;
        var doelwoord = delen[1].trim();
        if (!doelwoord) return;
        delen[0].split(',').forEach(function (sleutel) {
          var k = plat(sleutel);
          if (k) Dict.regels[k] = doelwoord;
        });
      });
      return Dict;
    }
  };

  /* Alles plat: kleine letters, geen accenten, geen apostrofs of streepjes.
     Daarmee is "loreal" hetzelfde als "L'Oréal". */
  function plat(tekst) {
    return (tekst || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/['’`´]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Aantal tikfouten tussen twee woorden (Damerau-Levenshtein: ook omgewisselde
     letters, want "conditinoer" is één beweging). Stopt zodra het verschil te
     groot wordt — dan hoeft de rest niet meer berekend te worden. */
  function tikfouten(a, b, grens) {
    if (a === b) return 0;
    if (Math.abs(a.length - b.length) > grens) return grens + 1;
    /* Drie rijen: de huidige, de vorige en die daarvoor. Die laatste is nodig
       voor omgewisselde letters ("conditinoer"), waar één beweging genoeg is. */
    var tweeTerug = null;
    var vorige = [];
    var huidige;
    var i;
    var j;
    for (j = 0; j <= b.length; j++) vorige[j] = j;
    for (i = 1; i <= a.length; i++) {
      huidige = [i];
      var kleinste = i;
      for (j = 1; j <= b.length; j++) {
        var kosten = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var waarde = Math.min(
          vorige[j] + 1,
          huidige[j - 1] + 1,
          vorige[j - 1] + kosten
        );
        if (
          i > 1 &&
          j > 1 &&
          tweeTerug &&
          a.charAt(i - 1) === b.charAt(j - 2) &&
          a.charAt(i - 2) === b.charAt(j - 1)
        ) {
          waarde = Math.min(waarde, tweeTerug[j - 2] + 1);
        }
        huidige[j] = waarde;
        if (waarde < kleinste) kleinste = waarde;
      }
      if (kleinste > grens) return grens + 1;
      tweeTerug = vorige;
      vorige = huidige;
    }
    return vorige[b.length];
  }

  /* Hoeveel tikfouten mogen we toestaan? Bij korte woorden bijna niets, anders
     wordt "haar" ineens "haai". */
  function toegestaan(woord) {
    if (woord.length <= 4) return 0;
    if (woord.length <= 7) return 1;
    return Math.min(2, Dict.max);
  }

  function beste(platTerm, lijst) {
    var grens = toegestaan(platTerm);
    var winnaar = null;
    var winst = grens + 1;
    lijst.forEach(function (item) {
      if (item.plat === platTerm) {
        winnaar = item;
        winst = 0;
        return;
      }
      if (winst === 0 || grens === 0) return;
      var d = tikfouten(platTerm, item.plat, grens);
      if (d <= grens && d < winst) {
        winst = d;
        winnaar = item;
      }
    });
    return winnaar;
  }

  /* Geeft de verbeterde zoekterm, of null als er niets te verbeteren valt. */
  function verbeterTerm(term) {
    var d = Dict.voorbereid();
    var platte = plat(term);
    if (!platte) return null;

    if (d.regels[platte]) return d.regels[platte];

    /* Eerst de hele term als naam: "loreal profesionnel" hoort bij één merk. */
    var alles = d.merken.concat(d.woorden);
    var treffer = beste(platte, alles);
    if (treffer && plat(treffer.naam) !== platte) return treffer.naam;
    if (treffer && treffer.naam !== term) return treffer.naam;

    /* Anders woord voor woord: "loreal sampoo" wordt "L'Oréal Professionnel
       shampoo". Woorden die kloppen of te kort zijn blijven staan. */
    var woorden = platte.split(' ');
    if (woorden.length < 2) return null;
    var veranderd = false;
    var nieuw = woorden.map(function (woord) {
      if (d.regels[woord]) {
        veranderd = true;
        return d.regels[woord];
      }
      if (woord.length < 5) return woord;
      var hit = beste(woord, alles);
      if (hit && plat(hit.naam) !== woord) {
        veranderd = true;
        return hit.naam;
      }
      return woord;
    });
    return veranderd ? nieuw.join(' ') : null;
  }

  window.hwsSearchCorrect = verbeterTerm;

  /* ----------------------------------------------------- predictive search */

  class HwsSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-search-input]');
      this.resultsEl = this.querySelector('[data-search-results]');
      this.resetEl = this.querySelector('[data-search-reset]');
      this.defaultEl = this.closest('.hws-drawer')
        ? this.closest('.hws-drawer').querySelector('[data-search-default]')
        : null;
      if (!this.input || !this.resultsEl) return;
      this.abort = null;
      this.timer = null;
      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('keydown', this.onKeydown.bind(this));
      this.input.addEventListener('focus', this.onInput.bind(this));
      if (this.resetEl) {
        this.resetEl.addEventListener('click', this.clear.bind(this));
      }
      document.addEventListener('click', this.onDocumentClick.bind(this));
      /* De Esc-knop in het paneel komt uit de gerenderde sectie, dus per klik
         opzoeken in plaats van één keer binden. */
      this.resultsEl.addEventListener('click', this.onResultsClick.bind(this));
    }

    onResultsClick(event) {
      if (event.target.closest('[data-search-close]')) {
        event.preventDefault();
        this.close();
        this.input.focus();
      }
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    clear() {
      this.input.value = '';
      this.close();
      this.input.focus();
    }

    close() {
      this.resultsEl.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      if (this.resetEl) this.resetEl.hidden = true;
      if (this.defaultEl) this.defaultEl.hidden = false;
    }

    onInput() {
      var term = this.input.value.trim();
      this.correctie = null;
      if (this.resetEl) this.resetEl.hidden = term.length === 0;
      window.clearTimeout(this.timer);
      if (term.length < 2) {
        this.close();
        return;
      }
      var self = this;
      this.timer = window.setTimeout(function () {
        self.search(term, {});
      }, 220);
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key === 'Enter') {
        this.maybeJump(event);
        return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      var options = Array.prototype.slice.call(
        this.resultsEl.querySelectorAll('a[role="option"]')
      );
      if (!options.length) return;
      event.preventDefault();
      var index = options.indexOf(document.activeElement);
      var next = event.key === 'ArrowDown' ? index + 1 : index - 1;
      if (next < 0) next = options.length - 1;
      if (next >= options.length) next = 0;
      options[next].focus();
    }

    /* Typt de bezoeker een merk of categorie en drukt hij op enter, dan is de
       merk- of categoriepagina bijna altijd bedoeld — niet een zoekresultaat.
       We springen daar alleen naartoe bij een echte overeenkomst: de getypte
       tekst moet gelijk zijn aan de naam van het merk of de categorie, of daar
       het begin van zijn. Bij twijfel gebeurt er niets en gaat het formulier
       gewoon naar de zoekpagina. */
    /* Het merk uit de woordenlijst halen. Die kent de naam én de pagina, dus
       hiervoor hoeft het zoekpaneel niet eerst geladen te zijn — enter werkt
       meteen, ook in kleine letters. */
    zoekMerk(term) {
      var d = Dict.voorbereid();
      var p = plat(term);
      if (p.length < 3) return null;
      var exact = null;
      var begin = null;
      d.merken.forEach(function (merk) {
        if (!merk.url) return;
        if (merk.plat === p) {
          exact = merk;
          return;
        }
        if (!begin && p.length >= 5 && merk.plat.indexOf(p) === 0) begin = merk;
      });
      return exact || begin;
    }

    maybeJump(event) {
      /* Is er op een verbeterde term gezocht ("loreal" → "L'Oréal
         Professionnel"), dan hoort enter dáár naartoe te gaan; het formulier zou
         anders de typefout naar de zoekpagina sturen en niets vinden. */
      var getypt = (this.input.value || '').trim();
      var term = plat(this.correctie || getypt);
      if (this.dataset.jumpToPage === 'false') {
        if (this.correctie) this.gaNaarZoekpagina(event);
        return;
      }
      var merk = this.zoekMerk(this.correctie || getypt);
      if (merk) {
        event.preventDefault();
        window.location.href = merk.url;
        return;
      }

      if (term.length < 3 || !this.resultsEl || this.resultsEl.hidden) return;

      var links = Array.prototype.slice.call(
        this.resultsEl.querySelectorAll('.search-panel__aside a[role="option"]')
      );

      var exact = null;
      var prefix = null;
      links.forEach(function (link) {
        var label = plat(link.textContent || '');
        if (!label) return;
        if (!exact && label === term) exact = link;
        /* Alleen een bijna-gelijke naam mag als treffer gelden. Zonder die grens
           stuurde "shampoo" de bezoeker naar "Shampoo Beschadigd Haar": dat begint
           met de zoekterm, maar het is een veel smallere categorie dan bedoeld. */
        if (!prefix && label.indexOf(term) === 0 && label.length - term.length <= 3) prefix = link;
      });

      var target = exact || prefix;
      if (!target) {
        if (this.correctie) this.gaNaarZoekpagina(event);
        return;
      }
      event.preventDefault();
      window.location.href = target.getAttribute('href');
    }

    gaNaarZoekpagina(event) {
      event.preventDefault();
      var basis = config.routes && config.routes.search ? config.routes.search : '/search';
      window.location.href = basis + '?q=' + encodeURIComponent(this.correctie);
    }

    /* De bezoeker moet zien dat er iets anders gezocht is dan hij typte, anders
       lijkt het alsof de winkel zijn typefout gewoon kende. */
    meldCorrectie(gebruikt, getypt) {
      if (!getypt) return;
      var melding = document.createElement('p');
      melding.className = 'search-results__corrected';
      melding.textContent =
        (strings.searchCorrectedFor || '') +
        ' ' +
        gebruikt +
        ' · ' +
        (strings.searchCorrectedTyped || '') +
        ' ' +
        getypt;
      this.resultsEl.insertBefore(melding, this.resultsEl.firstChild);
    }

    /* Vond de zoekopdracht wel een categorie maar geen product ("beschadigd
       haar"), dan zet de sectie daar alvast de producten van die categorie
       neer, in de volgorde van de categorie zelf. Hier halen we diezelfde lijst
       nog eens op met sort_by=best-selling, zodat het populairste product
       bovenaan komt. Mislukt dat, dan blijft simpelweg de eerste lijst staan. */
    vulAanvullendeProducten() {
      var vak = this.resultsEl.querySelector('[data-search-related]');
      if (!vak) return;
      var handle = vak.getAttribute('data-search-related');
      if (!handle || vak.hasAttribute('data-search-related-done')) return;
      vak.setAttribute('data-search-related-done', '');
      var url =
        '/collections/' +
        encodeURIComponent(handle) +
        '?sort_by=best-selling&section_id=search-related-products';
      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('geen sectie');
          return response.text();
        })
        .then(function (text) {
          var lijst = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-search-related-list]');
          if (!lijst || !lijst.querySelector('.search-result')) return;
          if (!vak.isConnected) return;
          vak.innerHTML = lijst.innerHTML;
        })
        .catch(function () {
          /* De eerste lijst staat er al; stil laten staan. */
        });
    }

    resourceTypes() {
      var types = [];
      if (this.getAttribute('data-types')) return this.getAttribute('data-types');
      types.push('product');
      return types.join(',');
    }

    search(term, opties) {
      opties = opties || {};
      if (this.abort) this.abort.abort();
      this.abort = new AbortController();
      var params = new URLSearchParams();
      params.set('q', term);
      params.set('resources[limit]', '6');
      params.set('resources[limit_scope]', 'each');
      params.set('section_id', 'predictive-search');
      var types = [];
      if (config.searchProducts !== false) types.push('product');
      if (config.searchCollections !== false) types.push('collection');
      if (config.searchPages !== false) types.push('page');
      if (config.searchArticles !== false) types.push('article');
      params.set('resources[type]', types.join(','));

      var self = this;
      fetch(config.routes.predictiveSearch + '?' + params.toString(), {
        signal: this.abort.signal
      })
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var parsed = new DOMParser().parseFromString(text, 'text/html');
          var results = parsed.querySelector('[data-predictive-results]');

          /* Niets gevonden? Dan pas kijken of de winkel een naam kent die er erg
             op lijkt: "loreal" → "L'Oréal Professionnel", "sampoo" → "shampoo".
             Zo blijft een zoekopdracht die het wél vindt onaangeroerd. */
          var aantal = results ? Number(results.getAttribute('data-result-count') || 0) : 0;
          if (aantal === 0 && !opties.corrected) {
            var beter = verbeterTerm(term);
            if (beter && plat(beter) !== plat(term)) {
              self.search(beter, { corrected: true, typed: term });
              return;
            }
          }
          self.correctie = opties.corrected && aantal > 0 ? term : null;

          self.resultsEl.innerHTML = results
            ? results.innerHTML
            : '<p class="search-results__empty">' + (strings.noResults || '') + '</p>';
          if (opties.corrected && aantal > 0) {
            self.meldCorrectie(term, opties.typed);
          }
          self.resultsEl.hidden = false;
          self.input.setAttribute('aria-expanded', 'true');
          if (self.defaultEl) self.defaultEl.hidden = true;
          self.vulAanvullendeProducten();
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          self.close();
        });
    }
  }

  if (!customElements.get('hws-search')) {
    customElements.define('hws-search', HwsSearch);
  }

  /* Op de zoekpagina zelf: leverde de zoekopdracht niets op, dan bieden we de
     verbeterde term als link aan. Doorsturen doen we niet — de bezoeker beslist
     zelf of hij dat bedoelde. */
  function initSearchSuggestion(root) {
    (root || document).querySelectorAll('[data-search-suggestion]').forEach(function (el) {
      if (el.dataset.ready === 'true') return;
      el.dataset.ready = 'true';
      var getypt = el.getAttribute('data-typed') || '';
      if (!getypt) return;
      var beter = verbeterTerm(getypt);
      if (!beter || plat(beter) === plat(getypt)) return;

      var link = document.createElement('a');
      link.className = 'search-page__did-you-mean-link';
      link.href = (config.routes && config.routes.search ? config.routes.search : '/search') +
        '?q=' + encodeURIComponent(beter);
      link.textContent = beter;

      el.textContent = (strings.searchDidYouMean || '') + ' ';
      el.appendChild(link);
      el.hidden = false;
    });
  }

  /* De uitnodigende tekst in de zoekbalk is op een telefoon te lang en werd
     halverwege afgekapt. Daar zetten we de korte versie neer. */
  function initSearchPlaceholder() {
    var smal = window.matchMedia('(max-width: 749px)');
    document.querySelectorAll('[data-search-input][data-placeholder-mobile]').forEach(function (input) {
      if (!input.dataset.placeholderWide) {
        input.dataset.placeholderWide = input.getAttribute('placeholder') || '';
      }
      var zetNeer = function () {
        input.setAttribute(
          'placeholder',
          smal.matches ? input.getAttribute('data-placeholder-mobile') : input.dataset.placeholderWide
        );
      };
      zetNeer();
      if (smal.addEventListener) smal.addEventListener('change', zetNeer);
    });
  }

  /* Het mobiele menu staat in een <template> (zie mobile-menu.liquid). Erin zetten zodra de
     pagina geladen is, of eerder bij de eerste tik op de menuknop. */
  function initMobielMenu() {
    function vul() {
      var t = document.querySelector('template[data-mobiel-menu-lijst]');
      if (t) t.replaceWith(t.content.cloneNode(true));
    }
    document.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('[aria-controls="MobileMenu"]')) vul();
    }, { capture: true, passive: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[aria-controls="MobileMenu"]')) vul();
    }, true);
    if (document.readyState === 'complete') vul();
    else window.addEventListener('load', vul, { once: true });
  }

  /* De woordenlijst van de zoekbalk staat niet meer in elke pagina (dat kostte rekentijd op de
     server). Ophalen zodra iemand de zoekbalk aanraakt, of in rust na het laden; daarna bouwt
     Dict.voorbereid() hem bij het volgende gebruik opnieuw op. */
  function laadWoordenlijst() {
    if (window.hwsSearchDict || laadWoordenlijst.bezig) return;
    laadWoordenlijst.bezig = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?section_id=zoek-woordenlijst', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-zoek-woordenlijst]');
        if (!el) throw new Error('leeg');
        window.hwsSearchDict = JSON.parse(el.textContent);
        Dict.klaar = false;
        Dict.merken = [];
        Dict.woorden = [];
        Dict.regels = {};
      })
      .catch(function () { laadWoordenlijst.bezig = false; });
  }
  function initWoordenlijst() {
    document.addEventListener('focusin', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input[type="search"], input[name="q"], [data-search-input]')) laadWoordenlijst();
    });
    document.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('[aria-controls*="Search"], [data-overlay-open*="Search"]')) laadWoordenlijst();
    }, { passive: true });
    var rust = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(laadWoordenlijst, { timeout: 6000 });
      else setTimeout(laadWoordenlijst, 3000);
    };
    if (document.readyState === 'complete') rust();
    else window.addEventListener('load', rust, { once: true });
  }

  function boot() {
    initWoordenlijst();
    initMobielMenu();
    initMegaMenus();
    initUtilityMarquee();
    initBrandFilter();
    initSearchSuggestion();
    initSearchPlaceholder();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initMegaMenus(event.target);
    initBrandFilter(event.target);
  });
})();
